import { FC } from "react";

import Image from "@/components/ui/Image/Image";
import useMediaQuery from "@/hooks/useMediaQuery";
import { EditorialModuleImage } from "@/types";

const TiledBlockV4: FC<{ items: EditorialModuleImage[] }> = ({ items }) => {
  const isMobile = useMediaQuery("(max-width: 600px)");
  return (
    <div className="grid grid-cols-1 h-full w-full">
      <div className="col-span-1 grid grid-cols-1">
        <Image
          src={isMobile ? items[0].mobileImage?.url ?? items[0].image!.url : items[0].image!.url}
          width={100}
          height={200}
          className="w-full h-full rounded-lg aspect-2-1"
          alt={items[0].image!.title}
        />
      </div>
    </div>
  );
};
export default TiledBlockV4;
